var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRequest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 15.4444V15.4556M11 1C19 1 21 3 21 11C21 19 19 21 11 21C3 21 1 19 1 11C1 3 3 1 11 1Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9987 12.1112C11.4984 12.1127 11.9841 11.9457 12.3772 11.6372C12.7703 11.3287 13.048 10.8967 13.1654 10.411C13.2828 9.92524 13.233 9.41411 13.0242 8.96013C12.8153 8.50615 12.4595 8.13582 12.0143 7.90895C11.5722 7.68252 11.0666 7.61231 10.5796 7.70975C10.0926 7.80719 9.6529 8.06654 9.33203 8.44562",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequest);
export default __webpack_public_path__ + "static/media/request.f8cdb62f79a12126010620cbee05c82e.svg";
export { ForwardRef as ReactComponent };